var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-suitcase-423882") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---12---Filters",
    transform: "translate(-1197.000000, -136.000000)",
    fill: "#44B739",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(20.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy-5",
    transform: "translate(1082.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-suitcase-423882",
    transform: "translate(30.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8267943,3.44497608 L14.4862967,3.44497608 L14.4862967,1.51596172 C14.4862967,0.718303349 13.8369962,0.0689856459 13.0393206,0.0689856459 L7.25184689,0.0689856459 C6.45418852,0.0689856459 5.80487081,0.718286124 5.80487081,1.51596172 L5.80487081,3.44497608 L1.46437321,3.44497608 C0.666714833,3.44497608 0.0173971292,4.09427656 0.0173971292,4.89195215 L0.0173971292,16.4670718 C0.0173971292,17.2647301 0.666697608,17.9140478 1.46437321,17.9140478 L18.8270526,17.9140478 C19.624711,17.9140478 20.2740287,17.2647474 20.2740287,16.4670718 L20.2740287,4.89195215 C20.2733559,4.09429378 19.6243923,3.44497608 18.8267081,3.44497608 L18.8267943,3.44497608 Z M15.4504593,4.40948325 L15.4504593,16.9491962 L4.83993301,16.9491962 L4.83993301,4.40948325 L15.4504593,4.40948325 Z M6.76911962,1.5158756 C6.76911962,1.24976842 6.98510239,1.03344115 7.25155407,1.03344115 L13.0390278,1.03344115 C13.304799,1.03344115 13.5214622,1.24942392 13.5214622,1.5158756 L13.5214622,3.44488995 L6.76948134,3.44488995 L6.76911962,1.5158756 Z M0.981301435,16.4670718 L0.981301435,4.89195215 C0.981301435,4.62584498 1.19728421,4.4095177 1.46373589,4.4095177 L3.87521914,4.4095177 L3.87521914,16.9492306 L1.46373589,16.9492306 C1.19762871,16.9492306 0.981301435,16.7332478 0.981301435,16.4667962 L0.981301435,16.4670718 Z M19.3085742,16.4670718 C19.3085742,16.7331789 19.0919196,16.9495062 18.8261397,16.9495062 L16.4146565,16.9495062 L16.4146565,4.4097933 L18.8261397,4.4097933 C19.091911,4.4097933 19.3085742,4.62577608 19.3085742,4.89222775 L19.3085742,16.4670718 Z",
    id: "Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.220b19a5dca6b1d5db0d644872b72c78.svg";
export { ForwardRef as ReactComponent };